var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnekeygrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 23.333332061767578,
    height: 23.548004150390625,
    viewBox: "0 0 23.333332061767578 23.548004150390625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.47032,12.0629Q4.04295,10.1713,1.78934,11.5235Q-0.614798,12.966,0.211238,14.8698C0.257999,14.9776,0.320355,15.0788,0.388105,15.1748L5.60138,22.5603C6.03859,23.1797,6.74948,23.548,7.50764,23.548L21,23.548C22.2887,23.548,23.3333,22.5033,23.3333,21.2147L23.3333,13.1032C23.3333,12.1491,22.7524,11.2911,21.8666,10.9368L15.818,8.51736L15.818,3.50715Q15.3169,0,12.3108,0Q9.30467,0,8.80365,3.50715L8.80365,11.0262L8.80365,14.5296L7.0143,12.5255Q6.74123,12.274,6.47032,12.0629ZM5.35465,14.1702Q4.53258,13.4337,3.90866,13.314Q3.47795,13.2314,2.98982,13.5243Q2.55331,13.7862,2.38761,13.9613L7.50764,21.2147L21,21.2147L21,13.1032L14.9514,10.6838C14.0655,10.3295,13.4846,9.47148,13.4846,8.51736L13.4846,3.6853Q13.3416,2.82761,13.0407,2.5267Q12.8474,2.33333,12.3108,2.33333Q11.7742,2.33333,11.5809,2.5267Q11.28,2.82761,11.137,3.6853L11.137,14.5296C11.137,15.8183,10.0923,16.863,8.80365,16.863C8.13896,16.863,7.50582,16.5795,7.06313,16.0837L5.35465,14.1702Z",
    fillRule: "evenodd",
    fill: "#8E94A9",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnekeygrey);
export default __webpack_public_path__ + "static/media/onekeygrey.631df94c0a07950635dc59a0a10bc39a.svg";
export { ForwardRef as ReactComponent };